/*
 * PublisherFilter Messages
 *
 * This contains all the text for the PublisherFilter component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  allPublishers: {
    id: 'app.components.PublisherFilter.allPublishers',
    defaultMessage: 'All publishers',
  },
  active: {
    id: 'app.components.PublisherFilter.active',
    defaultMessage: 'Active',
  },
  inactive: {
    id: 'app.components.PublisherFilter.inactive',
    defaultMessage: 'Inactive',
  },
  invited: {
    id: 'app.components.PublisherFilter.invited',
    defaultMessage: 'Invited',
  },
  atRiskToBecomeInactive: {
    id: 'app.components.PublisherFilter.atRiskToBecomeInactive',
    defaultMessage: 'At risk to become inactive',
  },
  none: {
    id: 'app.components.PublisherFilter.none',
    defaultMessage: 'None',
  },
  regularPioneer: {
    id: 'app.components.PublisherFilter.regularPioneer',
    defaultMessage: 'Regular Pioneer',
  },
  specialPioneer: {
    id: 'app.components.PublisherFilter.specialPioneer',
    defaultMessage: 'Special Pioneer',
  },
  circuitOverseer: {
    id: 'app.components.PublisherFilter.circuitOverseer',
    defaultMessage: 'Circuit Overseer',
  },
  elder: {
    id: 'app.components.PublisherFilter.elder',
    defaultMessage: 'Elder',
  },
  ministerialServant: {
    id: 'app.components.PublisherFilter.ministerialServant',
    defaultMessage: 'Ministerial Servant',
  },
  congregation: {
    id: 'app.components.PublisherFilter.congregation',
    defaultMessage: 'Congregation',
  },
  state: {
    id: 'app.components.PublisherFilter.state',
    defaultMessage: 'State',
  },
  pioneerLevel: {
    id: 'app.components.PublisherFilter.pioneerLevel',
    defaultMessage: 'Pioneer level',
  },
  privilege: {
    id: 'app.components.PublisherFilter.privilege',
    defaultMessage: 'Privilege',
  },
  experienceLevel: {
    id: 'app.components.PublisherFilter.experienceLevel',
    defaultMessage: 'Experience',
  },
  newbie: {
    id: 'app.components.PublisherFilter.newbie',
    defaultMessage: 'Newbie',
  },
  common: {
    id: 'app.components.PublisherFilter.common',
    defaultMessage: 'Common',
  },
  mentor: {
    id: 'app.components.PublisherFilter.mentor',
    defaultMessage: 'Mentor',
  },
  role: {
    id: 'app.components.PublisherFilter.role',
    defaultMessage: 'Role',
  },
  isAdministrator: {
    id: 'app.components.PublisherFilter.isAdministrator',
    defaultMessage: 'Administrator',
  },
  isVip: {
    id: 'app.components.PublisherFilter.isVip',
    defaultMessage: 'VIP',
  },
  isPublisher: {
    id: 'app.components.PublisherFilter.isPublisher',
    defaultMessage: 'Publisher',
  },
  isShiftLeader: {
    id: 'app.components.PublisherFilter.isShiftLeader',
    defaultMessage: 'Team leader',
  },
});
